// 商城底部切换
<template>
    <div class="shopTabbar">
        <div class="tabbarContent" :style="index==choosedIndex?styleBox.fontStyle:{}" v-for="(item,index) in tabbarData" :key="index" @click="changeRoute(item,index)">
            <i class="iconfont" :class="[item.iconfont]"></i>
            <p>{{item.tabName}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            tabbarData:[
                {
                    tabName: '积分兑换',
					path: '/shoppingMall/commodity',
					iconfont:'icon-shangcheng'
                }
                // ,{
                //     tabName: '购物车',
				// 	path: '/shoppingMall/shoppingCart',
				// 	iconfont:'icon-gouwuche'
                // }
                ,{
                    tabName: '兑换记录',
					path: '/shoppingMall/order',
					iconfont:'icon-dingdan'
                },
            ],
            choosedIndex:0, //默认第一个
        }
    },
    created(){
        for(var i=0;i<this.tabbarData.length;i++){
            if(this.tabbarData[i].path==this.$route.path){
                this.choosedIndex=i;
            }
        }
    },
    methods:{
        // 切换路由
        changeRoute(val,index){
            if(val.path!== this.$route.path){
				this.choosedIndex=index;
				this.$router.push({path:val.path});
			}
        }
    }
}
</script>

<style  scoped>
    .shopTabbar{
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        border-top: 1px solid #ddd;
        box-sizing: border-box;
    }
    .tabbarContent{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 10px;
    }
    .iconfont{
        font-size: 20px;
    }
    .icon-gouwuche{
       font-size: 22px;
    }
    .icon-dingdan{
        font-size: 22px;
    }
</style>